var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocationOn = function SvgLocationOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.6,
    clipPath: "url(#location_on_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.667A5.83 5.83 0 0 0 4.165 7.5c0 4.375 5.833 10.833 5.833 10.833s5.834-6.458 5.834-10.833a5.83 5.83 0 0 0-5.834-5.833M5.832 7.5c0-2.3 1.866-4.167 4.166-4.167S14.166 5.2 14.166 7.5c0 2.4-2.4 5.992-4.167 8.233C8.266 13.508 5.833 9.875 5.833 7.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9.583a2.083 2.083 0 1 0 0-4.166 2.083 2.083 0 0 0 0 4.166"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "location_on_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgLocationOn;